import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";

import { reorderFileTypeMetaCategory } from '../../../actions/fileData'
import ReactSortable from 'react-sortablejs';

class FileTypeOrder extends Component {

	constructor(props,context) {
        super(props,context);
        this.onChangeOrder = this.onChangeOrder.bind(this);
        this.columns = [
        {
            Header: 'ID',
            accessor: 'file_type_to_metacategory_id',

        }, {
            Header: 'Waarde',
            accessor: 'name',

        }, {
            Header: 'Kan gebruikt worden voor notificatie?',
            accessor: 'is_notifier',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        }
        ]

        this.state = {'valueData': false}

    }

	componentWillMount() {    	
        
        
        if(this.props.categoryid)
        {
            const categoryId = this.props.categoryid;
            const fileType = this.props.fileTypeData.data.find(e => e.id === categoryId);
             this.setState({valueData: fileType.metacategories})
        }
       
  	}

    renderSortableRows(key) {            

            const data = this.state.valueData;       
            const dataByKey = data[key];
           
            return(
                <li key={key} data-id={key} >
                    <div className="inner-col">{dataByKey.file_type_to_metacategory_id}</div>
                    <div className="inner-col">{dataByKey.name}</div>
                    <div className="inner-col">{dataByKey.is_notifier === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</div>                 
                </li>
        )
    }

    onChangeOrder(order, sortable, evt) {
       
       
        
        let newItemOrder = [];
        const oldItemOrder = this.state.valueData;     
       
        for(let key in order) {
            newItemOrder.push(oldItemOrder[order[key]]);
        }

        this.setState({ valueData: newItemOrder });
        
        const newId = newItemOrder[evt.newIndex];
        const newIdBefore = newItemOrder[evt.newIndex - 1];
        const newIdAfter = newItemOrder[evt.newIndex + 1];

        const serverData = {
            before_id: newIdBefore, 
            current_id: newId, 
            after_id: newIdAfter           
        }
        

        this.props.reorderFileTypeMetaCategory(this.props.clientPath.clientPath, serverData);
    }


	render() {

        return (
            <Card>				
                <CardBody>
                    <CardTitle><i className="fa fa-align-justify"></i> Metadata waarde overzicht</CardTitle>
                    <div className="sortable">
                        <div className="sortable-title">ID</div>
                        <div className="sortable-title">Waarde</div>
                        <div className="sortable-title">Is urgent melding?</div>                      
                        <ReactSortable tag="ul" onChange={(order, sortable, evt) => this.onChangeOrder(order, sortable, evt) }>
                            {this.state.valueData ? Object.keys(this.state.valueData).map(this.renderSortableRows, this) : ''}
                        </ReactSortable>
                    </div>
                </CardBody>
            </Card>
        )
  	}
}

function mapStateToProps(state, ownProps) {

    return {     
       fileTypeData: state.FileTypeDataReducer,
       clientPath: state.clientPathReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reorderFileTypeMetaCategory: (clientPath, data) => dispatch(reorderFileTypeMetaCategory(clientPath, data)),

    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FileTypeOrder)



// WEBPACK FOOTER //
// ./src/views/Filetype/FileTypeOrder/index.js